// src/components/FlashMessage.tsx
import React from "react";
import { useError } from "../../context/ErrorContext";
import { Notification } from "../../components/Notification/Notification";

const FlashMessage: React.FC = () => {
  const { error, clearError } = useError();

  if (!error?.data?.message) return null;

  return (
    <Notification
      key={"notification-error"}
      message={error?.data?.message}
      type={error?.type}
      duration={3000}
      onClose={clearError}
      placement={error?.data?.placement || "top"}
    />
  );
};

export default FlashMessage;
